import React from 'react'
import shortid from "shortid";

const ImageOnly = ({ blogSectionObj, theme }) => {
    var content = blogSectionObj;
    const handleErrorImageLoading = ({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = content.attributes.fallbackImageUrl ? content.attributes.fallbackImageUrl : "";
    }
    return (
        <>
            <div key={shortid.generate()} className='col-md-12 col-sm-12 col-lg-12 col-12' data-type="ImageOnly">
                <div className='card-design'>
                    {content.mainImage ? <img src={`${content.mainImage ? content.mainImage : ""}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} onError={handleErrorImageLoading} className='img-fluid' alt={content.attributes.altText} /> : ""}
                </div>
            {theme.horizontalRuler == 'true' ? <hr className='mx-5'></hr> : ""}

            </div>
        </>
    )
}

export default ImageOnly
